module.exports = __webpack_public_path__ + "static/thaheifers-drone-video-d203a7aa45323e4ef0fd6909df03c615.webm";